import { RegularCurrencies, SystemCurrency } from '@okletsplay/core';
import { Option as ButtonOption } from 'shared/components/OptionsWithInput/Option';
import { convertCryptoToUsd, formatCrypto, formatFiat } from 'shared/utils';
import { WithdrawAmounts } from '../interfaces';

const convertAndFormatFiat = (cryptoAmount: number, exchangeRate: number) => {
  const fiatAmount = convertCryptoToUsd(cryptoAmount, exchangeRate);

  return `(${formatFiat(fiatAmount)})`;
};

const getAmountOptions = (
  amounts: WithdrawAmounts,
  exchangeRate: number,
  currency: SystemCurrency,
  isDisabled = false
): ButtonOption[] => {
  return amounts[currency as RegularCurrencies].map((value) => {
    const subLabel =
      currency !== SystemCurrency.USDT ? convertAndFormatFiat(value, exchangeRate) : undefined;

    return {
      value,
      label: formatCrypto(value, currency),
      subLabel,
      disabled: isDisabled,
    };
  });
};

export const getWithdrawAmountOptions = (
  amounts: WithdrawAmounts,
  balance: number | undefined,
  exchangeRate: number,
  currency: SystemCurrency,
  isDisabled = false
): ButtonOption[] => {
  const options = getAmountOptions(amounts, exchangeRate, currency, isDisabled);

  if (balance) {
    options.push({
      value: balance,
      label: 'MAX',
      disabled: isDisabled,
    });
  }

  return options;
};
